import type { FaireProductEntity } from "../../entity_types/product";

export const p_d6rh6t4jz5: FaireProductEntity = {
  token: "p_d6rh6t4jz5",
  type: "product",
  name: "18K Gold Cross Pendant Necklace",
  brandToken: "b_xju99kcstz",
  brandName: "paperln",
  imageUrl:
    "https://cdn.faire.com/fastly/d054c059978721c1ad726b432cc217b0e7336a261fea3290c575c2b0e1d22d12.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e1a410fc2e9047a7de1b38ec5fc50794e37f48093b81a619bfdae191850cc0d5.jpeg",
    "https://cdn.faire.com/fastly/c68c6c7dc4f0bda1458446d1b2aa583cf3fbc64b6cdfb925a42924af5c7da92c.jpeg",
    "https://cdn.faire.com/fastly/4eff7fc33b7c82fc69d68f357d48e0a50033a02fcd40c59b234f90560c7ea7de.jpeg",
  ],
  priceDollars: 13.86,
  description:
    "Enhance your style with this elegant 18K gold cross pendant necklace, perfect for any occasion. The sleek design and shimmering finish make it a versatile piece that can be worn alone or layered with other necklaces. \n\nFeatures:\n- 18K gold plating for a luxurious look\n- Cross pendant symbolizes faith and elegance\n- Adjustable chain length for a perfect fit\n\nMaterials:\n- High-quality 18K gold plating\n\nStyling Suggestions:\n- Pair with casual or formal outfits\n- Layer with other gold necklaces for a trendy look\n\nCare Instructions:\n- Store in a dry place\n- Avoid contact with water and harsh chemicals\n- Clean with a soft cloth to maintain shine",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:18.841Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
